import { useEffect, useState, useCallback } from "react";
import axiosInstance from "services/httpInterceptor";

const API_URLS = {
  linkedin: `/v1/frontend/linkedin/barchart-data`,
  x: `/v1/frontend/x/barchart-data`,
};

export const useBarChartData = (companyId, competitorId, platform, presetKey) => {

  const [barChartData, setBarChartData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [companiesPostsSummary, setCompaniesPostsSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(() => {
    if (!companyId || !competitorId || !platform || !presetKey) {
      setBarChartData([]); // Clear data if params are missing
      setCategories([]);
      setCompaniesPostsSummary(null);
      return;
    }

    setLoading(true);
    setError(null);

    axiosInstance
      .get(API_URLS[platform], { params: { companyId, competitorId, preset: presetKey.toUpperCase() } })
      .then((response) => {
        const { series: newSeries, categories: newCategories, companiesPostsSummary: newSummary } = response.data;

        const newSeriesOrDefault = newSeries || [];
        setBarChartData(currentSeries =>
          JSON.stringify(currentSeries) !== JSON.stringify(newSeriesOrDefault) ? newSeriesOrDefault : currentSeries,
        );

        const newCategoriesOrDefault = newCategories || [];
        setCategories(currentCategories =>
          JSON.stringify(currentCategories) !== JSON.stringify(newCategoriesOrDefault) ? newCategoriesOrDefault : currentCategories,
        );

        const newSummaryOrDefault = newSummary || null; // Ensure null if that's the default from useState
        setCompaniesPostsSummary(currentSummaryData =>
          JSON.stringify(currentSummaryData) !== JSON.stringify(newSummaryOrDefault) ? newSummaryOrDefault : currentSummaryData,
        );
      })
      .catch((error) => {
        console.error(`Error fetching ${platform} chart data:`, error);
        setError(`Failed to load ${platform} chart data`);
        setBarChartData([]);
        setCategories([]);
        setCompaniesPostsSummary(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [companyId, competitorId, platform, presetKey]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { barChartData, categories, companiesPostsSummary, loading, error };
};